// @ts-nocheck
/* eslint-disable */
import { Scene, _ } from "~/route/globals";
import { buildSummaryModule } from "./main";
import { icon, node, text } from "~/util/dom";
import { ROUTE_CONST } from "~/route/const";
import { store } from "~/state/store";
import { setCoordinates } from "~/state/map/state";
import { ROUTE_MULTIPLE } from "~/ui/sds-compatible-icons";
import createSDSIcon from "~/ui/icon";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";
import { WASM_ZINDEX } from "~/wasm/const";
import { CONFIG } from "~/config";

export default class ModuleItinerary {
	_opened: boolean;

	_elms: ReturnType<typeof buildSummaryModule>;

	_container: HTMLDivElement;

	_poiLayer: any;

	_poiMarker: any;

	_wasLoaded: boolean;

	_responseData: any;

	_routeState: any;

	_wasmMarker: WasmStoreMarker;

	constructor(responseData, routeState) {
		const { longitude, latitude } = store.getState().map;

		this._responseData = responseData;
		this._routeState = routeState;
		this._elms = buildSummaryModule({
			title: _("route.result.itinerary.title"),
			sdsIcon: createSDSIcon({ className: "icon-multiple", symbol: ROUTE_MULTIPLE }),
			className: "route-itinerary content",
			headerClassName: "route-itinerary-form-header",
			switcher: false,
		});

		this._wasLoaded = !!routeState.itinerary;
		this._opened = routeState.itinerary;
		this._container = this._elms.container;
		this._elms.header.addEventListener("click", this, false);
		this._poiLayer = Scene.createLayerMarker("route-results");
		this._poiMarker = Scene.createMarker(Scene.coordsFromWGS84(longitude, latitude), null, {
			anchor: {
				left: 12,
				bottom: 12,
			},
			url: "/img/route/marker.png",
		});
		this._wasmMarker = new WasmStoreMarker({
			type: "height-profile",
			visible: false,
			zIndex: WASM_ZINDEX.marker.heightProfile,
		});

		this._set();
	}

	destroy() {
		if (this._poiLayer.isActive()) {
			this._poiLayer.disable();
			Scene.removeLayer(this._poiLayer);
		}
		this._elms.header.removeEventListener("click", this, false);
		this._container.remove();
		this._wasmMarker.destroy();
	}

	get container() {
		return this._container;
	}

	reloadState() {
		const prevOpened = this._opened;

		this._opened = Mapy.CML.state.route.itineraryOpen;
		this._container.classList[this._opened ? "add" : "remove"]("open");

		prevOpened !== this._opened && this._set();
	}

	handleEvent() {
		this._opened = !this._opened;
		this._container.classList[this._opened ? "add" : "remove"]("open");

		Mapy.CML.state = {
			route: {
				itineraryOpen: this._opened,
			},
		};

		if ((!this._wasLoaded && this._opened) || !this._opened) {
			Mapy.CML.state = {
				route: {
					itinerary: this._opened,
				},
			};
		}

		Mapy.getComponent("logger").log("click", { text: this._opened ? "Zobrazit itinerář" : "Skrýt itinerář" });

		this._set();
	}

	_set() {
		if (this._opened && this._responseData && this._responseData.itinerary) {
			if (!this._poiLayer.isActive()) {
				Scene.addLayer(this._poiLayer).enable();
			}
			this._container.classList.add("open");

			// ruzne typy
			let isCar = this._routeState.params.type === ROUTE_CONST.TYPE_CAR;
			let isBike = this._routeState.params.type === ROUTE_CONST.TYPE_BIKE;
			let items = node("div", { className: "itinerary" });
			let len = this._responseData.itinerary.length;


			this._responseData.itinerary.forEach((r, index) => {
				const allCoords = this._routeState.items[index]?.path[this._responseData.index] ? Scene.stringToCoords(this._routeState.items[index].path[this._responseData.index]) : [];

				r.forEach((i, ind) => {
					const el = node("div", { className: "item" });
					const coords = allCoords[i.index];
					const isStart = index === 0 && ind === 0;
					const isEnd = index === len - 1 && r.length - 1 === ind;
					const isTrough = index !== 0 && ind === 0;
					let createData = null;

					if (isStart || isEnd || isTrough) {
						el.classList.add("extra");
						el.classList.add(isStart ? "start" : (isEnd ? "end" : "through"));
						el.appendChild(this._createMarkerItem(isStart
							? this._routeState.items[index]?.title || ""
							: (isEnd
								? this._routeState.items[this._routeState.items.length - 1]?.title || ""
								: this._routeState.items[index]?.title || ""
							), isStart ? _("route.item.start") : (isEnd ? _("route.item.end") : ""))
						);
					} else {
						if (i.commandType === "ClosureEnd" || i.commandType === "WarningEnd" || i.commandType === "Destination") {
							return;
						}

						if (isCar || isBike) {
							createData = this._createItem(i);
							el.appendChild(createData.text);
						}
						else {
							// pesi
							createData = this._createItem(i, true);
							el.appendChild(createData.text);
						}
						// interaktivita
						el.addEventListener("mouseenter", e => {
							this._poiMarker.setCoords(coords);
							this._wasmMarker.update({
								visible: true,
								lon: coords.x,
								lat: coords.y,
							});
							this._poiLayer.addMarker(this._poiMarker);
						});
						el.addEventListener("mouseleave", e => {
							this._poiLayer.removeMarker(this._poiMarker);
							this._wasmMarker.update({
								visible: false,
							});
						});
					}

					// kliknuti
					el.addEventListener("click", e => {
						e.preventDefault();
						if (createData?.detailData) {
							Mapy.getComponent("detail").setState({
								id: createData.detailData.id,
								source: createData.detailData.source,
								show: false
							}).then(() => Mapy.getComponent("history").save(), () => {});
						} else {
							const { zoom } = store.getState().map;
							const [longitude, latitude] = coords.toWGS84();

							store.dispatch(setCoordinates({
								longitude,
								latitude,
								zoom: Math.max(zoom, 15),
								animate: true,
							}));
							Mapy.getComponent("history").save(true);
						}
					});

					items.appendChild(el);
				});
			});

			this._elms.switcherContainer.appendChild(items);
		} else {
			this._container.classList.remove("open");
			this._elms.switcherContainer.innerHTML = "";
		}
	}

	_createMarkerItem(name, txt) {
		const title = node("p");
		const marker = node("a", { className: "marker" });
		const names = name.split(",");
		const titleName = names.shift();
		const markerType = `https://api.mapy.${CONFIG.TLD}/img/api/wmmarker/${txt === "" ? "universal" : "middle"}`;

		marker.classList.add(txt === "" ? "type-universal" : "type-middle");

		const beforeSpan = node("span", { className: "before" });
		const beforeImg = node("img", {
			src: `${markerType}.png`,
			srcset: `${markerType}.png 1x, ${markerType}@2x.png 2x, ${markerType}@3x.png 3x`,
			crossOrigin: "true"
		});

		beforeSpan.appendChild(beforeImg);

		const wrapperSpan = node("span", { className: "marker-bg-wrapper" });
		const wrapperImg = node("img", {
			src: `${markerType}.png`,
			srcset: `${markerType}.png 1x, ${markerType}@2x.png 2x, ${markerType}@3x.png 3x`,
			crossOrigin: "true"
		});

		wrapperSpan.appendChild(wrapperImg);

		marker.appendChild(beforeSpan);
		marker.appendChild(wrapperSpan);
		txt !== "" && marker.appendChild(node("span", { className: "text" }, txt));
		title.appendChild(marker);
		title.appendChild(text(titleName));
		title.appendChild(node("br"));
		title.appendChild(node("em", { textContent: names.join(", ") }));

		return title;
	}

	_createItem(data, isTurist) {
		let detailData = null;
		const command = data.commandType.toLowerCase();
		const paragraph = node("p");

		if (isTurist) {
			paragraph.classList.add("turist");
		}

		if (data.commandType === "ClosureStart" || data.commandType === "ClosureEnd") {
			// uzavirka
			paragraph.classList.add("closure");
			let svg = "no-entry";

			if (data.id && data.source) {
				detailData = {
					id: data.id,
					source: data.source,
				};
			}
			else {
				svg = ROUTE_CONST.closureImages[this._routeState.params.type] || "no-entry";
			}

			paragraph.appendChild(icon(svg));
			paragraph.appendChild(text(data.commandText));
		} else if (data.commandType === "WarningStart" || data.commandType === "WarningEnd") {
			paragraph.classList.add("warning");

			if (data.id && data.source) {
				detailData = {
					id: data.id,
					source: data.source,
				};
			}

			paragraph.appendChild(icon(data.warningType === "via_ferrata" ? "warning-ferrata" : "warning-sign"));
			paragraph.appendChild(text(data.commandText));
		} else {
			let src = "";

			if (isTurist && command in ROUTE_CONST.itinerary.turistImages) {
				src = "/img/route/" + ROUTE_CONST.itinerary.turistImages[command] + ".png";
			} else if (command in ROUTE_CONST.itinerary.carImages) {
				src = "/img/route/" + ROUTE_CONST.itinerary.carImages[command] + ".gif";
			}

			const image = node("img");

			image.classList.add("itinerary-img");
			image.src = src;
			paragraph.appendChild(image);
			paragraph.appendChild(text(data.commandText));

			const iconData = ROUTE_CONST.itinerary.turistTypes[data.color];

			if (iconData) {
				paragraph.innerHTML += "&nbsp;";
				const iconImage = node("img");

				iconImage.src = `/img/route/${iconData.icon}.png`;
				iconImage.style.height = `${iconData.height}px`;
				iconImage.style.width = `${iconData.width}px`;
				paragraph.appendChild(iconImage);
			}
		}

		return {
			text: paragraph,
			detailData,
		};
	}
}
